import React from "react";

export const ArrowDownIcon = ({color = "var(--color-dark)", size = "w-[26px]"}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 720 720" enableBackground="new 0 0 720 720" className={size}>
      <path fillRule="evenodd" clipRule="evenodd" fill={color ?? "#2A3B53"} d="M334.5,400.5l-186.6-212
	c-16.4-18.6-41.6-16-55.4,5.9l0,0c-12.9,20.5-11,50.4,4.4,67.8l237.6,269.2c14.5,16.5,36.4,16.5,51,0l237.6-269.2
	c15.4-17.5,17.4-47.3,4.4-67.8l0,0c-13.8-21.8-39-24.5-55.4-5.9l-186.6,212C371,417,349,417,334.5,400.5z"/>
    </svg>

  );
};

export const ArrowLeftIcon = ({color = "var(--color-dark)", size = "w-[26px]"}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 720 720" enableBackground="new 0 0 720 720" className={size}>
      <path fill={color ?? "#2A3B53"} d="M319.4,334.5l212-186.6
      c18.6-16.4,16-41.6-5.9-55.4l0,0c-20.5-12.9-50.4-11-67.8,4.4L188.5,334.5c-16.5,14.5-16.5,36.4,0,51l269.2,237.6
      c17.5,15.4,47.3,17.4,67.8,4.4l0,0c21.8-13.8,24.5-39,5.9-55.4l-212-186.6C302.9,371,302.9,349,319.4,334.5z"/>
    </svg>
  )
}

export const ArrowRightIcon = ({color = "var(--color-dark)", size = "w-[26px]"}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 720 720" enableBackground="new 0 0 720 720" className={size}>
      <path fill={color ?? "#2A3B53"} d="M400.6,385.5l-212,186.6
      c-18.6,16.4-16,41.6,5.9,55.4l0,0c20.5,12.9,50.4,11,67.8-4.4l269.2-237.6c16.5-14.5,16.5-36.4,0-51L262.3,96.9
      c-17.5-15.4-47.3-17.4-67.8-4.4l0,0c-21.8,13.8-24.5,39-5.9,55.4l212,186.6C417.1,349,417.1,371,400.6,385.5z"/>
    </svg>
  )
}